// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"142":"7774aa2f","187":"52db4ed1","440":"36b1d4ac","581":"fcdc75ab","653":"5db6480d","917":"bcd9e18a"}[chunkId] + ".chunk.js";
};